import type { LatLong } from '@iheartjane/geolocation';
import { pluralize as pluralizeWord } from '@iheartjane/utils';
import isEmpty from 'lodash-es/isEmpty';

/* eslint-disable-next-line no-restricted-imports */
import type { Store } from '@jane/shared/models';
import type { Address } from '@jane/shared/types';

import { distance } from './location';
import { duration } from './timeUtils/calculateTime';

function pluralizeDistance(miles: number) {
  return pluralizeWord({ noun: 'mile', number: miles, returnValue: 'word' });
}

export function calculateDistance(
  userCoordinates: LatLong | undefined,
  storeCoordinates: LatLong
) {
  if (!userCoordinates || isEmpty(userCoordinates)) return 0;
  return parseFloat(distance(userCoordinates as LatLong, storeCoordinates));
}

export function isLocationInDeliveryDistance(
  userCoordinates: LatLong | undefined,
  store: Pick<Store, 'delivery_radius' | 'lat' | 'long'>
) {
  if (!userCoordinates) return true;
  if (store.delivery_radius == null) return true;

  const distance = calculateDistance(userCoordinates, store);
  return store.delivery_radius >= distance;
}

export function presentDistance(
  userCoordinates?: LatLong,
  storeCoordinates?: LatLong
) {
  if (
    !(
      userCoordinates &&
      userCoordinates.lat &&
      userCoordinates.long &&
      storeCoordinates &&
      storeCoordinates.lat &&
      storeCoordinates.long
    )
  )
    return '';

  const distance = calculateDistance(userCoordinates, storeCoordinates);

  return `${distance} ${pluralizeDistance(distance)} away`;
}

export const deliveryCoordinates = (
  deliveryAddress: Address | null
): LatLong | undefined =>
  deliveryAddress && deliveryAddress.lat && deliveryAddress.lng
    ? {
        lat: deliveryAddress.lat,
        long: deliveryAddress.lng,
      }
    : undefined;

export const formatLeadTimeMinutes = (maxLeadTimeMinutes: number) => {
  const days = duration(maxLeadTimeMinutes, 'minutes').days();
  const hours = duration(maxLeadTimeMinutes, 'minutes').hours();
  const minutes = duration(maxLeadTimeMinutes, 'minutes').minutes();

  const daysString = days > 0 ? `${days} days, ` : '';
  const hoursString = hours > 0 ? `${hours} hrs, ` : '';

  return `${daysString}${hoursString}${minutes} min`;
};
